import { render, staticRenderFns } from "./detail-general.vue?vue&type=template&id=74894752&lang=pug&"
import script from "./detail-general.vue?vue&type=script&lang=js&"
export * from "./detail-general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "detail-general.vue"
export default component.exports